import type { CommentContentObjectList, ContentObjectView } from 'models';
import { useTranslation } from 'react-i18next';
import { BookmarkLineIcon, Col, ReadMore, Row } from 'ui';
import { Attachments } from 'features/attachments';
import { useUnbookmarkObjectMutation } from 'features/bookmark';
import { ContentObjectFooter } from '../content-object-footer';
import { ContentObjectHeader } from '../content-object-header';
import { ContentObjectPreview } from '../content-object-preview';
import { ContentObjectTextContent } from '../content-object-text-content';

type P = {
  item: CommentContentObjectList;
  view: ContentObjectView;
};

const CommentBookmark = ({ item, view }: P) => {
  const { t } = useTranslation();
  const { mutate: unbookmark } = useUnbookmarkObjectMutation();

  const { attachments, createdAt, htmlContent: rawHtmlContent, id, textContent, type } = item;
  const htmlContent = rawHtmlContent ?? undefined;

  const actions = [
    {
      icon: <BookmarkLineIcon size="small" />,
      key: 'unbookmark',
      label: t('Unbookmark'),
      onClick() {
        unbookmark({ contentObject: item, type: 'rails' });
      },
    },
  ];

  return (
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <ContentObjectHeader actions={actions} item={item} subtitle={createdAt} view={view} />
      </Col>
      <Col span={24}>
        <ReadMore>
          <ContentObjectTextContent
            contentId={id}
            htmlContent={htmlContent}
            itemType={type}
            textContent={textContent}
          />
          {attachments.length > 0 ? <Attachments attachments={attachments} /> : null}
        </ReadMore>
      </Col>

      <Col span={24}>
        <ContentObjectFooter item={item} preview={<ContentObjectPreview item={item} view="other" />} view={view} />
      </Col>
    </Row>
  );
};

export default CommentBookmark;
